import { AfterContentInit, Component, ContentChildren, HostBinding, QueryList, Renderer2, ViewEncapsulation } from '@angular/core';
import { FuseWidgetToggleDirective } from './widget-toggle.directive';

@Component({
  selector: 'fuse-widget',
  templateUrl: './widget.component.html',
  styleUrls: ['./widget.component.scss'],
  encapsulation: ViewEncapsulation.None
})

export class FuseWidgetComponent implements AfterContentInit {
  @HostBinding('class.flipped')
  flipped = false;

  @ContentChildren(FuseWidgetToggleDirective, { descendants: true })
  toggleButtons: QueryList<FuseWidgetToggleDirective>;

  constructor(
    private readonly renderer: Renderer2
  ) {
  }

  ngAfterContentInit(): void {
    setTimeout(() => {
      this.toggleButtons.forEach(flipButton => {
        this.renderer.listen(flipButton.elementRef.nativeElement, 'click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          this.toggle();
        });
      });
    });
  }

  toggle(): void {
    this.flipped = !this.flipped;
  }

}
